import React from 'react';
import ChildChapterCard from './ChildChapterCard';
import { CHAPTER_DEFINITIONS } from '../../../utils/childChapterUtils';

/**
 * Renders all 5 chapter cards for a child.
 *
 * Overlays age-appropriate child chapter titles/descriptions
 * onto the backend chapter data based on the child's age band.
 *
 * Props:
 *   chapters  - array of chapter objects from the API
 *   memberId  - family member UUID
 *   isNewborn - boolean, if true the first chapter gets an urgency indicator
 *   ageBand   - string (infant, young_child, tween, teen) — if provided, overrides backend titles
 */
function ChildChapterList({ chapters, memberId, isNewborn, ageBand }) {
  if (!chapters || chapters.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500 text-lg">No chapters available yet.</p>
        <p className="text-gray-400 text-sm mt-1">Chapters will appear once a birth year is set.</p>
      </div>
    );
  }

  // Get child chapter definitions for overlay
  const childDefs = ageBand && CHAPTER_DEFINITIONS[ageBand] ? CHAPTER_DEFINITIONS[ageBand] : null;

  // Sort by number/index
  const sorted = [...chapters].sort((a, b) => (a.number || a.index || 0) - (b.number || b.index || 0));

  return (
    <div className="space-y-4">
      {sorted.map((chapter, idx) => {
        // Overlay child chapter definitions onto the backend chapter data
        let displayChapter = { ...chapter };
        if (childDefs && childDefs[idx]) {
          const def = childDefs[idx];
          displayChapter = {
            ...chapter,
            title: def.title,
            emoji: def.emoji,
            description: def.description,
            author_voice: def.authorVoice,
            note: def.note || def.description,
          };
        }

        return (
          <ChildChapterCard
            key={chapter.id || idx}
            chapter={displayChapter}
            memberId={memberId}
            isUrgent={isNewborn && idx === 0}
          />
        );
      })}
    </div>
  );
}

export default ChildChapterList;
